import React from 'react';
import {Route, Navigate, Outlet} from 'react-router-dom';
import {useAuth } from '../context/auth-context';

export default function PrivateRoute({isLogged}){
    const {currentUser} = useAuth();

    return currentUser ? <Outlet /> : <Navigate to='/login' />
}